/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type GetEvnForCustomerSortField =
  (typeof GetEvnForCustomerSortField)[keyof typeof GetEvnForCustomerSortField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEvnForCustomerSortField = {
  Datum: "Datum",
  Betrag: "Betrag",
} as const;
